export default class Actor extends PIXI.Container {
    constructor(texture) {
        super();

        texture = texture || PIXI.Texture.EMPTY;

        if (texture) {
            this.view = new PIXI.Sprite(texture);
            this.view.anchor = new PIXI.Point(0.5, 0.5);
            this.addChild(this.view);
        }
    }

    destroy() {
        super.destroy();
    }

    update() {}
}